module.exports = __webpack_public_path__ + "static/media/DogCitylogo2014.78f1adfe.webp";